{
	"title": "Projets",
	"table": {
		"reference": "Référence",
		"quantity": "Quantité totale",
		"savings": "Réductions totales de carbone",
		"fetchError": "Impossible de récupérer les projets"
	},
	"showProjectsHistoryTitle": "Afficher l’historique des projets",
	"noProjects": {
		"createDeclaration": "Créez votre première déclaration",
		"description": "Vous pouvez créer des déclarations pour un ou plusieurs matériaux en cliquant sur « Créer une déclaration »."
	}
}
